import { v4 as uuidv4 } from 'uuid';

async function refreshSubscriptions() {
    // Reset lists before re-fetching so we don't append duplicates
    this.subscriptions = [];
    this.inactiveSubscriptions = [];
    this.connectedSchedules = {};
    this.subscriptionDetails = {};
    this.page = { number: 1, limit: 10 };
    // Reset too, since getSubscriptions() adds onto totalLoaded rather than overwriting it.
    this.pageInfo = { currentPage: 1, totalPages: 1, totalRecords: 0, totalLoaded: 0 };

    await this.getSubscriptions();
}

export default refreshSubscriptions;
